<!-- Custom password requirements (always visible) -->
<div class="mb-3 rounded-md border bg-greyscale-50 p-3">
  <p *ngIf="showTitle" class="mb-2 text-xs font-medium text-greyscale-600">
    {{ getTitleTranslationKey() | transloco }}:
  </p>
  <div class="grid grid-cols-1 gap-1 text-xs md:grid-cols-2">
    <!-- Length requirement -->
    <div class="flex items-center">
      <i class="pi mr-1 text-xs" [ngClass]="getValidationIcon(isMinLengthValid.bind(this))"></i>
      <span [ngClass]="getValidationTextClass(isMinLengthValid.bind(this))">
        {{ getLengthTranslationKey() | transloco }}
      </span>
    </div>
    
    <!-- Uppercase requirement -->
    <div class="flex items-center">
      <i class="pi mr-1 text-xs" [ngClass]="getValidationIcon(hasUppercase.bind(this))"></i>
      <span [ngClass]="getValidationTextClass(hasUppercase.bind(this))">
        {{ getUppercaseTranslationKey() | transloco }}
      </span>
    </div>
    
    <!-- Lowercase requirement -->
    <div class="flex items-center">
      <i class="pi mr-1 text-xs" [ngClass]="getValidationIcon(hasLowercase.bind(this))"></i>
      <span [ngClass]="getValidationTextClass(hasLowercase.bind(this))">
        {{ getLowercaseTranslationKey() | transloco }}
      </span>
    </div>
    
    <!-- Number requirement -->
    <div class="flex items-center">
      <i class="pi mr-1 text-xs" [ngClass]="getValidationIcon(hasNumber.bind(this))"></i>
      <span [ngClass]="getValidationTextClass(hasNumber.bind(this))">
        {{ getNumericTranslationKey() | transloco }}
      </span>
    </div>
    
    <!-- Special character requirement -->
    <div class="flex items-center">
      <i class="pi mr-1 text-xs" [ngClass]="getValidationIcon(hasSpecialChar.bind(this))"></i>
      <span [ngClass]="getValidationTextClass(hasSpecialChar.bind(this))">
        {{ getSpecialTranslationKey() | transloco }}
      </span>
    </div>
  </div>
</div>